// apps/web/src/useRoute.js
// Migrated from src/react/useRoute.js

import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getRoute } from "@tennis-matches/core/router";

function readRoute() {
  try {
    return getRoute();
  } catch (_) {
    return "hub";
  }
}

/**
 * Liest die kanonische Route aus dem Legacy-Router (window.location).
 * useLocation als Dependency, damit Navigation via React Router sofort
 * einen Re-Render auslöst.
 */
export function useRoute() {
  const location = useLocation();
  const route = useMemo(
    () => readRoute(),
    [location.pathname, location.search, location.hash],
  );
  return { route };
}
